<template>
    <ContentOrLoading>
        <b-row v-if="!loading">                
            <b-col cols="12">
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Deportistas">
                            <div class="table table-responsive" v-if="bases">
                                <b-table 
                                striped
                                hover
                                :items="bases"
                                :per-page="per_page"
                                ></b-table>
                            </div>
                            <div class="text-right">
                                <b-pagination
                                    v-model="current_page"
                                    :total-rows="rows_bases"
                                    :per-page="per_page"
                                ></b-pagination>
                            </div>
                        </b-tab>
                        <b-tab title="Abonos">
                            <div class="table table-responsive" v-if="abonos">
                                <b-table 
                                striped
                                hover 
                                :items="abonos"
                                :per-page="per_page"
                                ></b-table>
                            </div>
                            <div class="text-right">
                                <b-pagination
                                    v-model="current_page"
                                    :total-rows="rows_abonos"
                                    :per-page="per_page"
                                ></b-pagination>
                            </div>
                        </b-tab>
                        <b-tab title="Datos tarjeta" :active="activo == 'tarjeta'">
                            <DatosTarjeta v-if="user.info_pago" @actualizarInfo="getUsuario(true)"></DatosTarjeta>
                            <h3 class="text-center" v-else>{{ $t('perfil.no_info_pago') }}</h3>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>
    </ContentOrLoading>
</template>

<script>
import DatosTarjeta from './components/DatosTarjeta';

export default {
    props: ['lista_id', 'user_id'],
    data() {
        return {
            loading: true,
            user: null,
            activo: null,
            bases: [],
            abonos: [],
            per_page: 10,
            current_page: 1
        }
    },
    methods: {
        getUsuario(tarjeta_actualizada = false) {
            this.loading = true;

            if (tarjeta_actualizada) {
                this.activo = 'tarjeta';
            }

            const params = {
                filters: {
                    lista_id: this.lista_id,
                    per_page: this.per_page
                },
                user_id: this.user_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.get'), params).then(res => {
                this.user = res.data.user;
                this.getBases();
                this.getAbonos();
            }).finally(() => {
                this.loading = false;
            });
        },
        getBases() {
            this.loading = true;

            const params = {
                filters: {
                    lista_id: this.lista_id,
                    per_page: this.per_page
                },
                user_id: this.user_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.bases'), params).then(res => {
                this.bases = res.data.bases;
            }).finally(() => {
                this.loading = false;
            });
        },
        getAbonos() {
            this.loading = true;

            const params = {
                filters: {
                    lista_id: this.lista_id,
                    per_page: this.per_page
                },
                user_id: this.user_id
            }

            this.$store.dispatch(this.config.getVuexAlias('back.usuarios.abonos'), params).then(res => {
                this.abonos = res.data.abonos;
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.getUsuario();
    },
    computed: {
        rows_abonos() {
            return this.abonos?.length ?? 0;
        },
        rows_bases() {
            return this.bases?.length ?? 0;
        }
    },
    components: {
        DatosTarjeta
    }    
}
</script>